// extracted by mini-css-extract-plugin
module.exports = {"root":"BaseModal_root__1KLKA","head":"BaseModal_head__3vhWQ"};